import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { providerApi } from "../../api/providerApi"
import { Alert, Spin, Collapse, Card, message, Button } from "antd"
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { ClientApi } from "../../api/clientApi"
const { Panel } = Collapse;

const ShowClientView = () => {
    const {id} = useParams()
    const [client, setClient] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };
      const fetchProvider = async () => {
        setLoading(true);
        setError(null);
        try {
          const res = await ClientApi.getClient(`${id}`,abortController.signal);
          setClient(res.data.customer); // Stocker les données récupérées

          console.log("details",res.data)
        } catch (err) {
          setError("Impossible de charger les détails du mécano.");
        } finally {
          setLoading(false);
        }
      };

    useEffect(() => {
        // Définir la fonction fetchProvider à l'intérieur de useEffect        
    
        fetchProvider(); // Appeler la fonction immédiatement
    
      }, [id]);
    
      const handleDeactivate = async (client) =>{
        // console.log(client)
        try {
          const res = await providerApi.canManageAnnonce(`${client.user_id}`,abortController.signal)
          if (res.success == true) {
            message.success("Gestion d'annonce desactivé pour cet utilisateur avec succès");
          }else{
            message.error(res.message);
          }
  
          fetchProvider()
  
        } catch (error) {
          console.error(error);
            setLoading(false);
            message.error("Échec d'activation des informations");
        }
      }
  
      const handleActivate = async (client) =>{
        // console.log(client)
        try {
          const res = await providerApi.canManageAnnonce(`${client.user_id}`,abortController.signal)
          if (res.success === true) {
            message.success("Gestion d'annonce activé pour cet utilisateur avec succès");
          }else{
            message.error(res.message);
          }
  
          fetchProvider()
        } catch (error) {
          console.error(error);
            setLoading(false);
            message.error("Échec d'activation des informations");
        }
      }


    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails du Client</h1>
            <Link to={`/gestion-clients/liste`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && client && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations personnelles" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom :</strong> {client.name} {client.lastname}</p>
                <p><strong>Email :</strong> {client.email || "Non fourni"}</p>
                <p><strong>Numéro de téléphone :</strong> {client.contact || "Non fourni"}</p>
                

                <p><strong>Date d'ajout :</strong> {formatDate(client.created_at)}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations de contact" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Adresse :</strong> {client.adresse || "Non fournie"}</p>
                <p><strong>Ville :</strong> {client.ville || "Non fournie"}</p>

              </div>
            </Panel>
          </Collapse>

          <div className="mt-2">
              {
                client?.user?.manage_announce_module === 1 &&
                <Button onClick={()=> handleDeactivate(client)} className="btn bg-red-700 text-white rounded-md">Desactiver la gestion des annonce</Button>
              }
              {
                client?.user?.manage_announce_module === 0 &&
                <Button onClick={()=> handleActivate(client)} className="btn bg-blue-700 text-white rounded-md">Activer la gestion des annonces</Button>
              }
          </div>

        </div>
      )}
    </div>
  </MainLayout>

}
export default ShowClientView